import { Component, OnInit } from '@angular/core';
import { ResetPasswordParameters } from 'src/app/models/ui/ChangePasswordParameters';
import { UserService } from 'src/app/services/user.service';
import { HelperService } from 'src/app/services/Helper/helper.service';
import notify from 'devextreme/ui/notify';
import { LookupService } from 'src/app/services/Lookup/lookup.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {  
  ngOnInit() {

  }
  
  resetPasswordParameters: ResetPasswordParameters;

  constructor(private userService: UserService, private helper: HelperService, private lookupService: LookupService) {  
    this.resetPasswordParameters = new ResetPasswordParameters();
  }

  getQuestions(e) {
    this.lookupService.getQuestions(this.resetPasswordParameters.Username).subscribe(data => {
      this.resetPasswordParameters.FirstQuestion = data.FirstQuestion;
      this.resetPasswordParameters.SecondQuestion = data.SecondQuestion;
    });
  }
  
  submitChanges(e) {
    setTimeout(() => {
      this.userService.resetPassword(this.resetPasswordParameters).subscribe(data => notify(data));
    }, 1000);
  }
}